import { updateObject } from '../../shared/utility';
import { CREATE_PRODUCT_START, CREATE_PRODUCT_SUCCESS, CREATE_PRODUCT_FAIL, GET_PRODUCT_START, GET_PRODUCT_SUCCESS, GET_PRODUCT_FAIL, OPEN_PRODUCT_EDIT_FORM, CLOSE_PRODUCT_EDIT_FORM, UPDATE_PRODUCT_START, UPDATE_PRODUCT_SUCCESS, UPDATE_PRODUCT_FAIL, CLEAR_PRODUCT_EDIT, DELETE_PRODUCT_START, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAIL } from '../actions/actionTypes';


const initialState = {
    error: null,
    loading: null,
    message: null,
    products: [],
    editProduct: {
        id: null,
        name: null,
    },
    visibleEditForm: false,
}

const createProductStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const createProductSuccess = (state, action) => {
    return updateObject(state, { error: null, loading: false, message: action.message });
}

const createProductFail = (state, action) => {
    return updateObject(state, { error: action.error, loading: false, message: null });
}

const getProductStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getProductSuccess = (state, action) => {
    return updateObject(state, { error: null, products: action.products, loading: false });
}

const getProductFail = (state, action) => {
    return updateObject(state, { error: action.error, loading: false })
}

const openProductEditForm = (state, action) => {
    return updateObject(state, {
        visibleEditForm: true,
        editProduct:action.product,
    });
}
const closeProductEditForm = (state, action) => {
    return updateObject(state, {
        visibleEditForm: false,
        editProduct:{
            id:null,
            name:null,
        }
    });
}

const updateProductStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}

const updateProductSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:action.message,loading:false});
}

const updateProductFail=(state,action)=>{
    return updateObject(state,{error:action.error,message:null,loading:false});
}

const clearProductEdit=(state,action)=>{
    return updateObject(state,{error:null,message:null});
}

const deleteProductStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}

const deleteProductSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:action.message,loading:false});
}

const deleteProductFail=(state,action)=>{
    return updateObject(state,{error:action.error,message:null,loading:false});
}
const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PRODUCT_START:
            return createProductStart(state, action);
        case CREATE_PRODUCT_SUCCESS:
            return createProductSuccess(state, action);
        case CREATE_PRODUCT_FAIL:
            return createProductFail(state, action);
        case GET_PRODUCT_START:
            return getProductStart(state, action);
        case GET_PRODUCT_SUCCESS:
            return getProductSuccess(state, action);
        case GET_PRODUCT_FAIL:
            return getProductFail(state, action);
        case OPEN_PRODUCT_EDIT_FORM:
            return openProductEditForm(state,action);
        case CLOSE_PRODUCT_EDIT_FORM:
            return closeProductEditForm(state,action);
        case UPDATE_PRODUCT_START:
            return updateProductStart(state,action);
        case UPDATE_PRODUCT_SUCCESS:
            return updateProductSuccess(state,action);
        case UPDATE_PRODUCT_FAIL:
            return updateProductFail(state,action);
        case CLEAR_PRODUCT_EDIT:
            return clearProductEdit(state,action);
        case DELETE_PRODUCT_START:
            return deleteProductStart(state,action);
        case DELETE_PRODUCT_SUCCESS:
            return deleteProductSuccess(state,action);
        case DELETE_PRODUCT_FAIL:
            return deleteProductFail(state,action);
        default:
            return state;
    }
}

export default productReducer;